module.exports = __webpack_public_path__ + "img/fun_activities1.489b85e3.png";